export default __webpack_public_path__ + "static/media/logo.911d8ceb.svg";